import './uploadResources.css'
import React, { useContext, useState, useRef, useEffect } from 'react'
import { createUploadResource } from '../../context/authContext/apiCalls'
import { AuthContext } from '../../context/authContext/AuthContext'
import { useHistory, useLocation } from 'react-router-dom'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'

import {
  Container,
  Grow,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
  FormControl,
  TextField,
  InputLabel,
  Button,
  Select,
  Paper,
  MenuItem
} from '@material-ui/core'
//import { useSelector, useDispatch } from 'react-redux'

const initialState = {
  name: '',
  email: '',
  password: '',
  isAdmin: false,
  isStudent: false
}
const UploadResources = () => {
  const [multipleProgress, setMultipleProgress] = useState(0)
  const bytesToMegaBytes = (bytes) => bytes / 1024 ** 2
  const { isFetching, message, error, dispatch } = useContext(AuthContext)
  const [postData, setPostData] = useState({
    title: '',
    multipleFiles: '',
    fileSize: '',
    categoryLocation: ''
  })

  useEffect(() => {
    if (message) {
      alert(message.message.data.message)
      setPostData({
        title: '',
        multipleFiles: '',
        fileSize: '',
        categoryLocation: ''
      })
      window.location.reload()
    }
  }, [message])

  const MultipleFileChange = (e) => {
    const { files } = e.target
    // console.log(files)
    Array.from(files).forEach((file) => {
      const fileSize = bytesToMegaBytes(file.size)
      // console.log(fileSize + 'MB')
      if (fileSize < 300) {
        setPostData({
          ...postData,
          multipleFiles: e.target.files,
          fileSize: ''
        })
      } else {
        e.target.value = null
        setPostData({
          ...postData,
          fileSize:
            'you must make sure the file size is less than or equal to 300MB.'
        })
      }
    })
  }
  const multipleFileOptions = {
    onUploadProgress: (progressEvent) => {
      const { loaded, total } = progressEvent
      const percentage = Math.floor(((loaded / 1000) * 100) / (total / 1000))
      setMultipleProgress(percentage)
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    if (postData.categoryLocation === '') {
      alert('Please select your category!')
    } else if (postData.multipleFiles.length > 0) {
      const formData = new FormData()
      formData.append('title', postData.title)
      formData.append('categoryLocation', postData.categoryLocation)
      formData.append('totalFile', postData.multipleFiles.length)
      for (let i = 0; i < postData.multipleFiles.length; i++) {
        formData.append('multipleFiles', postData.multipleFiles[i])
      }

      const fileUploaded = await createUploadResource(
        [formData, multipleFileOptions],
        dispatch
      )
      console.log(fileUploaded)
      // setUploadStatus(false)
      // if (currentId === 0) {
      // dispatch(createPost(formData, multipleFileOptions))
      //   setUploadStatus(false)

      //    clear()
      //  } else {
      // dispatch(
      //   updatePost(currentId, { ...postData, name: user?.result?.name })
      // )
      //   setUploadStatus(false)

      //     clear()
      //   }
    } else {
      alert('Please select file to upload!')
    }
  }

  return (
    <Grow in>
      <Container style={{ marginTop: '50px' }}>
        <Grid
          container
          justifyContent='space-between'
          alignItems='stretch'
          spacing={3}
          className='wrapper'
        >
          <Grid item xs={12} sm={12}>
            <div className='marketingResources'>
              <Typography
                className='heading'
                variant='h3'
                style={{ fontWeight: '300', fontSize: '15px' }}
              >
                Upload Resources
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={12}>
            <div className='wrapUploadResources'>
              <form
                encType='multipart/form-data'
                autoComplete='off'
                noValidate
                className='formUpload'
                onSubmit={handleSubmit}
              >
                <Paper className='boxOne'>
                  <FormControl fullWidth>
                    <InputLabel id='subDemo-simple-select-label-cate'>
                      Category
                    </InputLabel>

                    <Select
                      labelId='subDemo-simple-select-label-cate'
                      id='subDemo-simple-select-cate'
                      value={postData.categoryLocation}
                      label='Category'
                      onChange={(e) =>
                        setPostData({
                          ...postData,
                          categoryLocation: e.target.value
                        })
                      }
                    >
                      <MenuItem selected='selected' value=''>
                        Please select your category
                      </MenuItem>
                      <MenuItem value='Laser'>Laser</MenuItem>
                      <MenuItem value='Injection'>Injection</MenuItem>
                    </Select>
                  </FormControl>
                </Paper>
                <Paper className='boxTwo'>
                  <Typography variant='h6'>Upload File</Typography>
                  <TextField
                    name='title'
                    variant='outlined'
                    label='Title'
                    fullWidth
                    className='controlInput'
                    value={postData.title}
                    onChange={(e) =>
                      setPostData({ ...postData, title: e.target.value })
                    }
                  />

                  <div className='fileInput'>
                    <input
                      type='file'
                      className='formControlFile'
                      name='files'
                      onChange={(e) => MultipleFileChange(e)}
                    />
                  </div>
                  <CircularProgressbar
                    className='CircularProgressbar'
                    value={multipleProgress}
                    text={`${multipleProgress}%`}
                    styles={buildStyles({
                      rotation: 0.25,
                      strokeLinecap: 'butt',
                      textSize: '16px',
                      pathTransitionDuration: 0.5,
                      pathColor: `rgba(255,136,136, ${multipleProgress / 100})`,
                      textColor: '#f88',
                      trailColor: '#d6d6d6',
                      backgroundColor: '#3e98c7'
                    })}
                  />
                  <p>{postData.fileSize}</p>

                  <Button
                    className='buttonSubmit'
                    variant='contained'
                    color='primary'
                    size='large'
                    type='submit'
                    fullWidth
                  >
                    Upload
                  </Button>
                </Paper>
              </form>
            </div>
          </Grid>
        </Grid>
      </Container>
    </Grow>
  )
}
export default UploadResources
